


// navbar

$(document).ready(function () {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.up').fadeIn(400);
        } else { $('.up').fadeOut(400); }
    });

    $('.up').click(function (event) {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 800);
    });

});
const header = document.querySelector(".page-header");
const toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 150) {
        header.classList.add(toggleClass);
    } else {
        header.classList.remove(toggleClass);
    }
});
// end




$("#team-slid2").owlCarousel({
    items: 4,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    mouseDrag: true,
    autoplayTimeout: 3000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1,
            nav: true,
            margin: 20
        },
        600: {
            items: 4,
            nav: false,
            margin: 20
        },


        1000: {
            items:4,
            nav: false,
            loop: true,
            margin: 20
        }
    },

    navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



});











// ------------------header---------------------

const navbarMenu = document.getElementById("navbar");
const burgerMenu = document.getElementById("burger");
const overlayMenu = document.querySelector(".overlay");

// Show and Hide Navbar Function
const toggleMenu = () => {
   navbarMenu.classList.toggle("active");
   overlayMenu.classList.toggle("active");
};

// Collapsible Mobile Submenu Function
const collapseSubMenu = () => {
   navbarMenu
      .querySelector(".menu-dropdown.active .submenu")
      .removeAttribute("style");
   navbarMenu.querySelector(".menu-dropdown.active").classList.remove("active");
};

// Toggle Mobile Submenu Function
const toggleSubMenu = (e) => {
   if (e.target.hasAttribute("data-toggle") && window.innerWidth <= 992) {
      e.preventDefault();
      const menuDropdown = e.target.parentElement;

      // If Dropdown is Expanded, then Collapse It
      if (menuDropdown.classList.contains("active")) {
         collapseSubMenu();
      } else {
         // Collapse Existing Expanded Dropdown
         if (navbarMenu.querySelector(".menu-dropdown.active")) {
            collapseSubMenu();
         }

         // Expanded the New Dropdown
         menuDropdown.classList.add("active");
         const subMenu = menuDropdown.querySelector(".submenu");
         subMenu.style.maxHeight = subMenu.scrollHeight + "px";
      }
   }
};

// Fixed Resize Window Function
const resizeWindow = () => {
   if (window.innerWidth > 992) {
      if (navbarMenu.classList.contains("active")) {
         toggleMenu();
      }
      if (navbarMenu.querySelector(".menu-dropdown.active")) {
         collapseSubMenu();
      }
   }
};

// Initialize Event Listeners
burgerMenu.addEventListener("click", toggleMenu);
overlayMenu.addEventListener("click", toggleMenu);
navbarMenu.addEventListener("click", toggleSubMenu);
window.addEventListener("resize", resizeWindow);

// -------------------end------------------------


$(document).ready(function () {
    $("#bannerslider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]
    });
    $("#bannerslider2").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 0
            }
        },
        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]
    });



    $("#bannerslider3").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 2,
                nav: false,
                loop: true,
                margin: 0
            }
        },
        navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]
    });

    $("#bannerslider4").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 0
            }
        },
        navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]
    });

    $("#bannerslider5").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 0
            }
        },
        navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]
    });

    $("#bannerslider6").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 0
            }
        },
        navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]
    });





    $("#client-success").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1366: {
                items: 4,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });



    $("#offerSlider").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>",
            "<span><i class='fa fa-angle-right'></i></span>"]

    });

    $("#offerSlider1").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>",
            "<span><i class='fa fa-angle-right'></i></span>"]



    });







    $("#team-slide2").owlCarousel({
        items: 5,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 13
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });


    $("#team-slide3").owlCarousel({
        items: 5,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1366: {
                items: 1,
                nav: false,
                loop: true,
                margin: 13
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });



    //  $("#pro-slider").owlCarousel({
    //         items: 5,
    //         nav: true,
    //         dots: true,
    //         loop: true,
    //         autoplay: true,
    //         mouseDrag: true,
    //         autoplayTimeout: 3000,
    //         smartSpeed: 1000,
    //         autoplayHoverPause: true,
    //         responsive: {
    //             0: {
    //                 items: 1,
    //                 nav: true
    //             },
    //             600: {
    //                 items: 3,
    //                 nav: false
    //             },


    //             1366: {
    //                 items: 3,
    //                 nav: false,
    //                 loop: true,
    //                 margin: 30
    //             }
    //         },

    //         navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    //     });



    $("#team-slid").owlCarousel({
        items: 4,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span></span>",
            "<span></span>"]



    });


    $("#related-slid").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 26,
            }
        },

        navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]




    });



});

$("#related-slid1").owlCarousel({
    items: 4,
    nav: true,
    dots: true,
    loop: true,
    autoplay: true,
    mouseDrag: true,
    autoplayTimeout: 3000,
    smartSpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1,
            nav: true
        },
        600: {
            items: 3,
            nav: false
        },


        1366: {
            items: 4,
            nav: false,
            loop: true,
            margin: 30,
        }
    },

    navText: ["<span><i class='fa fa-arrow-left'></i></span>", "<span><i class='fa fa-arrow-right'></i></span>"]




});






jQuery(window).scroll(function () {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 200) {
        jQuery('header').addClass('fixed-nav');
    } else {
        jQuery('header').removeClass('fixed-nav');
    }
});




$(function () {
    var $gallery = $('.gallery a').simpleLightbox();

    $gallery.on('show.simplelightbox', function () {
        console.log('Requested for showing');
    })
        .on('shown.simplelightbox', function () {
            console.log('Shown');
        })
        .on('close.simplelightbox', function () {
            console.log('Requested for closing');
        })
        .on('closed.simplelightbox', function () {
            console.log('Closed');
        })
        .on('change.simplelightbox', function () {
            console.log('Requested for change');
        })
        .on('next.simplelightbox', function () {
            console.log('Requested for next');
        })
        .on('prev.simplelightbox', function () {
            console.log('Requested for prev');
        })
        .on('nextImageLoaded.simplelightbox', function () {
            console.log('Next image loaded');
        })
        .on('prevImageLoaded.simplelightbox', function () {
            console.log('Prev image loaded');
        })
        .on('changed.simplelightbox', function () {
            console.log('Image changed');
        })
        .on('nextDone.simplelightbox', function () {
            console.log('Image changed to next');
        })
        .on('prevDone.simplelightbox', function () {
            console.log('Image changed to prev');
        })
        .on('error.simplelightbox', function (e) {
            console.log('No image found, go to the next/prev');
            console.log(e);
        });
});

jQuery(document).ready(function ($) {
    var feedbackSlider = $(".feedback-slider");
    feedbackSlider.owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        autoplay: true,
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        navText: [
            "<i class='fa fa-long-arrow-left'></i>",
            "<i class='fa fa-long-arrow-right'></i>"
        ],
        responsive: {
            // breakpoint from 767 up
            767: {
                nav: true,
                dots: false
            }
        }
    });

    feedbackSlider.on("translate.owl.carousel", function () {
        $(".feedback-slider-item h3")
            .removeClass("animated fadeIn")
            .css("opacity", "0");
        $(".feedback-slider-item img, .feedback-slider-thumb img, .customer-rating")
            .removeClass("animated zoomIn")
            .css("opacity", "0");
    });

    feedbackSlider.on("translated.owl.carousel", function () {
        $(".feedback-slider-item h3").addClass("animated fadeIn").css("opacity", "1");
        $(".feedback-slider-item img, .feedback-slider-thumb img, .customer-rating")
            .addClass("animated zoomIn")
            .css("opacity", "1");
    });
    feedbackSlider.on("changed.owl.carousel", function (property) {
        var current = property.item.index;
        var prevThumb = $(property.target)
            .find(".owl-item")
            .eq(current)
            .prev()
            .find("img")
            .attr("src");
        var nextThumb = $(property.target)
            .find(".owl-item")
            .eq(current)
            .next()
            .find("img")
            .attr("src");
        var prevRating = $(property.target)
            .find(".owl-item")
            .eq(current)
            .prev()
            .find("span")
            .attr("data-rating");
        var nextRating = $(property.target)
            .find(".owl-item")
            .eq(current)
            .next()
            .find("span")
            .attr("data-rating");
        $(".thumb-prev").find("img").attr("src", prevThumb);
        $(".thumb-next").find("img").attr("src", nextThumb);
        $(".thumb-prev")
            .find("span")
            .next()
            .html(prevRating + '<i class="fa fa-star"></i>');
        $(".thumb-next")
            .find("span")
            .next()
            .html(nextRating + '<i class="fa fa-star"></i>');
    });
    $(".thumb-next").on("click", function () {
        feedbackSlider.trigger("next.owl.carousel", [300]);
        return false;
    });
    $(".thumb-prev").on("click", function () {
        feedbackSlider.trigger("prev.owl.carousel", [300]);
        return false;
    });
}); //end ready

$(function () {
    var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.article-title');
        links.on('click', {
            el: this.el,
            multiple: this.multiple
        }, this.dropdown)
    }

    Accordion.prototype.dropdown = function (e) {
        var $el = e.data.el;
        $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
        };
    }
    var accordion = new Accordion($('.accordion-container'), false);
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('#accordion').length) {
        $this.parent().toggleClass('open');
    }
});

var counted = 0;
$(window).scroll(function () {

    var oTop = $('#counter').offset().top - window.innerHeight;
    if (counted == 0 && $(window).scrollTop() > oTop) {
        $('.count').each(function () {
            var $this = $(this),
                countTo = $this.attr('data-count');
            $({
                countNum: $this.text()
            }).animate({
                countNum: countTo
            },

                {

                    duration: 2000,
                    easing: 'swing',
                    step: function () {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function () {
                        $this.text(this.countNum);
                        //alert('finished');
                    }

                });
        });
        counted = 1;
    }

});

const clickBtn = document.getElementById("clickBtn");
const popup = document.getElementById("popup");
const closeBtn = document.getElementById("closeBtn");

clickBtn.addEventListener('click', () => {
    popup.style.display = 'block';
});
closeBtn.addEventListener('click', () => {
    popup.style.display = 'none';
});
popup.addEventListener('click', () => {
    popup.style.display = 'none';
});

$(document).ready(function () {
    $("#bannerslider").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        navText: ["<span><i class='fa fa-angle-right'></i></span>", "<span><i class='fa fa-angle-left'></i></span>"]
    });




    $("#client-success").owlCarousel({
        items: 2,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });







    $("#offerSlider").owlCarousel({
        items: 3,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 3,
                nav: false,
                loop: true,
                margin: 30
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });

    $("#offerSlider1").owlCarousel({
        items: 2,
        nav: true,
        dots: true,
        loop: true,
        autoplay: false,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 1,
                nav: false
            },


            1000: {
                items: 2,
                nav: false,
                loop: true,
                margin: 20
            }
        },

        navText: ["<span><i class='fa fa-angle-left'></i></span>", "<span><i class='fa fa-angle-right'></i></span>"]



    });






    //  $("#team-slid1").owlCarousel({
    //         items: 1,
    //         nav: true,
    //         dots: true,
    //         loop: true,
    //         autoplay: true,
    //         mouseDrag: true,
    //         autoplayTimeout: 3000,
    //         smartSpeed: 1000,
    //         autoplayHoverPause: true,
    //         responsive: {
    //             0: {
    //                 items: 1,
    //                 nav: true
    //             },
    //             600: {
    //                 items: 2,
    //                 nav: false
    //             },


    //             1000: {
    //                 items: 1,
    //                 nav: false,
    //                 loop: true,
    //                 margin: 30
    //             }
    //         },

    //         navText: ["<span><i class='fa-solid fa-arrow-left'></i></span>", "<span><i class='fa-solid fa-arrow-right'></i></span>"]



    //     });



    $("#related-slid").owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 4,
                nav: false,
                loop: true,
                margin: 10
            }
        },

        navText: ["<span></span>", "<span></span>"]




    });


    $("#related-slid2").owlCarousel({
        items: 2,
        nav: true,
        dots: true,
        loop: true,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 2,
                nav: true
            },
            600: {
                items: 2,
                nav: false
            },


            1000: {
                items: 1,
                nav: false,
                loop: true,
                margin: 26,
            }
        },

        navText: ["<span></span>",
            "<span></span>"]




    });






});







// $(document).ready(function() {
//     $(window).scroll(function() {
//         if ($(this).scrollTop() > 200) {
//             $('.up').fadeIn(400);
//         } else { $('.up').fadeOut(400); }
//     });

//     $('.up').click(function(event) {
//         event.preventDefault();
//         $('html, body').animate({ scrollTop: 0 }, 800);
//     });

// });



// jQuery(window).scroll(function() {
//     var scroll = jQuery(window).scrollTop();
//     if (scroll >=1024) {
//         jQuery('header').addClass('fixed-nav');
//     } else {
//         jQuery('header').removeClass('fixed-nav');
//     }
// });









$(function () {
    var $gallery = $('.gallery a').simpleLightbox();

    $gallery.on('show.simplelightbox', function () {
        console.log('Requested for showing');
    })
        .on('shown.simplelightbox', function () {
            console.log('Shown');
        })
        .on('close.simplelightbox', function () {
            console.log('Requested for closing');
        })
        .on('closed.simplelightbox', function () {
            console.log('Closed');
        })
        .on('change.simplelightbox', function () {
            console.log('Requested for change');
        })
        .on('next.simplelightbox', function () {
            console.log('Requested for next');
        })
        .on('prev.simplelightbox', function () {
            console.log('Requested for prev');
        })
        .on('nextImageLoaded.simplelightbox', function () {
            console.log('Next image loaded');
        })
        .on('prevImageLoaded.simplelightbox', function () {
            console.log('Prev image loaded');
        })
        .on('changed.simplelightbox', function () {
            console.log('Image changed');
        })
        .on('nextDone.simplelightbox', function () {
            console.log('Image changed to next');
        })
        .on('prevDone.simplelightbox', function () {
            console.log('Image changed to prev');
        })
        .on('error.simplelightbox', function (e) {
            console.log('No image found, go to the next/prev');
            console.log(e);
        });
});

